var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",class:( _obj = { bold: _vm.bold }, _obj[_vm.size] = true, _obj )},[_c('div',{staticClass:"item-name",style:(_vm.itemStyle)},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"item-content",style:(_vm.itemStyle)},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }